export default __webpack_public_path__ + "static/media/assign.a639351a.svg";